import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { ObservationType } from "../../models/observation-type.model";
import { Api } from "../util/api";

@Injectable()
export class ObservationTypesService {
  private endpoint: string = 'observationTypes';

  constructor(private api: Api) {
  }

  createObservationType(observationType: ObservationType): Observable<ObservationType> {
    return this.api.put(`${this.endpoint}`, observationType);
  }

  getObservationTypes(): Observable<ObservationType[]> {
    return this.api.get(`${this.endpoint}`);
  }

  handleSuccess() {
    this.api.handleSuccess(null);
  }

  updateObservationType(observationType: ObservationType): Observable<ObservationType> {
    return this.api.put(`${this.endpoint}/${observationType.id}`, observationType);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/observation-types.service.ts